import(/* webpackMode: "eager", webpackExports: ["ReadingListsCarousel"] */ "/app/apps/galatea-web/src/components/ReadingListsCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TrackableLink"] */ "/app/apps/galatea-web/src/components/TrackableLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadingListsTitle"] */ "/app/apps/galatea-web/src/modules/shelf-page/components/ReadingListsTitle.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SimilarBooks"] */ "/app/apps/galatea-web/src/modules/summary/components/SimilarBooks.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SummaryPage"] */ "/app/apps/galatea-web/src/modules/summary/components/SummaryPage.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/utils-web/src/lib/common/i18n/LanguageChangeProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/libs/utils-web/src/lib/common/i18n/TranslationsClientProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@unleash/nextjs/dist/FlagProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@unleash/nextjs/dist/hooks.js");
